// extracted by mini-css-extract-plugin
export default {"vertical_menu":"style_vertical_menu__wuCCC","title":"style_title__E5yj3","active":"style_active__xQ+A9","root":"style_root__pF5GZ","loginForm":"style_loginForm__HZ2ao"};